import { combineReducers } from '@reduxjs/toolkit';

import { breachesCountReducer } from '@proton/account';
import { sharedReducers } from '@proton/redux-shared-store/sharedReducers';

export const rootReducer = combineReducers({
    ...sharedReducers,
    ...breachesCountReducer,
});

export type DriveState = ReturnType<typeof rootReducer>;
